import React from "react";

const TournamentResultsFilters = ({
  searchTerm,
  setSearchTerm,
  selectedEvent,
  setSelectedEvent,
  eventNames,
  filteredResultsCount,
  totalResultsCount,
}) => {
  const handleClearSearch = () => {
    setSearchTerm("");
  };

  return (
    <section role="search" aria-label="Tournament results filters">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Search Bar */}
        <div className="flex-1">
          <label
            htmlFor="search"
            className="block text-sm font-medium text-brand-charcoal mb-2"
          >
            Search teams
          </label>
          <div className="relative">
            <input
              type="text"
              id="search"
              placeholder="Search by team name or bowler name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 pr-10 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal placeholder-brand-mist focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
              aria-describedby="search-description"
              aria-label="Search tournament results by team name or bowler name"
            />
            {searchTerm && (
              <button
                type="button"
                onClick={handleClearSearch}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-brand-mist hover:text-brand-charcoal focus:outline-none"
                aria-label="Clear search"
                title="Clear search"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
          <div id="search-description" className="sr-only" aria-live="polite">
            {searchTerm
              ? `Searching for "${searchTerm}". Found ${filteredResultsCount} of ${totalResultsCount} results.`
              : `Showing all ${totalResultsCount} results.`}
          </div>
        </div>

        {/* Event Filter */}
        <div className="sm:w-48">
          <label
            htmlFor="eventFilter"
            className="block text-sm font-medium text-brand-charcoal mb-2"
          >
            Event
          </label>
          <select
            id="eventFilter"
            value={selectedEvent}
            onChange={(e) => setSelectedEvent(e.target.value)}
            className="w-full px-3 py-2 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
            aria-label="Filter results by tournament event"
            aria-describedby="event-filter-description"
          >
            <option value="all">All Events</option>
            {eventNames.map((event) => (
              <option key={event.id} value={event.id}>
                {event.name}
              </option>
            ))}
          </select>
          <div
            id="event-filter-description"
            className="sr-only"
            aria-live="polite"
          >
            {selectedEvent === "all"
              ? "Showing results from all events."
              : `Filtering results for ${
                  eventNames.find((e) => e.id === selectedEvent)?.name ||
                  "selected event"
                }.`}
          </div>
        </div>

        {/* Results Count */}
        <div className="sm:w-32 flex items-end">
          <div
            className="text-sm text-brand-muted pb-2"
            role="status"
            aria-live="polite"
            aria-label="Results count"
          >
            <span className="sr-only">Showing </span>
            {filteredResultsCount} of {totalResultsCount} results
          </div>
        </div>
      </div>

      {/* Screen reader summary of current filters */}
      <div className="sr-only" aria-live="polite">
        {searchTerm && selectedEvent !== "all"
          ? `Filtered results: ${filteredResultsCount} of ${totalResultsCount} results match "${searchTerm}" in ${
              eventNames.find((e) => e.id === selectedEvent)?.name ||
              "selected event"
            }.`
          : searchTerm
          ? `Search results: ${filteredResultsCount} of ${totalResultsCount} results match "${searchTerm}".`
          : selectedEvent !== "all"
          ? `Event filter: ${filteredResultsCount} of ${totalResultsCount} results in ${
              eventNames.find((e) => e.id === selectedEvent)?.name ||
              "selected event"
            }.`
          : `Showing all ${totalResultsCount} results.`}
      </div>
    </section>
  );
};

export default TournamentResultsFilters;
